/* Sticky add-to-cart bar (snippets/product-sticky-bar.liquid).
   The bar never submits anything itself: its button clicks the page's own
   Add to Cart, so quantity, the selected variant, stock errors and the cart
   drawer all go through product-form.js as usual. */
(() => {
  const init = (bar) => {
    const sectionId = bar.dataset.section;
    const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!mainButton) return;

    const button = bar.querySelector("[data-ld-sticky-add]");
    const price = bar.querySelector("[data-ld-sticky-price]");

    const setVisible = (visible) => {
      bar.classList.toggle("is-visible", visible);
      // Off-screen buttons shouldn't be reachable with Tab.
      bar.inert = !visible;
    };
    setVisible(false);

    // The label is the first non-empty text node in the button's span; the
    // variant picker rewrites it to "Sold out" / "Unavailable".
    const readLabel = () => {
      const span = mainButton.querySelector(".button__label") || mainButton.querySelector("span");
      const node = span && Array.from(span.childNodes).find(
        (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
      );
      return (node ? node.textContent : mainButton.textContent).trim();
    };

    // price-<section> is re-rendered from the server on every variant change.
    const readPrice = () => {
      const source = document.getElementById(`price-${sectionId}`);
      if (!source) return null;
      const onSale = source.querySelector(".price--on-sale");
      const item = onSale
        ? source.querySelector(".price__sale .price-item--sale")
        : source.querySelector(".price__regular .price-item--regular");
      return item ? item.textContent.trim() : null;
    };

    const sync = () => {
      button.disabled = mainButton.disabled;
      const label = readLabel();
      if (label) button.textContent = label;
      const current = readPrice();
      if (current && price) price.textContent = current;
    };
    sync();

    new MutationObserver(sync).observe(mainButton, {
      attributes: true,
      attributeFilter: ["disabled"],
      childList: true,
      characterData: true,
      subtree: true,
    });
    const priceSource = document.getElementById(`price-${sectionId}`);
    if (priceSource) {
      new MutationObserver(sync).observe(priceSource, { childList: true, subtree: true });
    }

    // Visible whenever the main button is fully out of the viewport, above or
    // below. A passive scroll check rather than an IntersectionObserver: it's
    // one rect read per event and behaves the same in every browser.
    let visible = false;
    const check = () => {
      const rect = mainButton.getBoundingClientRect();
      const outOfView = rect.bottom <= 0 || rect.top >= window.innerHeight;
      if (outOfView !== visible) {
        visible = outOfView;
        setVisible(visible);
      }
    };
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check, { passive: true });
    check();

    button.addEventListener("click", () => {
      if (mainButton.disabled) return;
      mainButton.click();
    });
  };

  const start = () => document.querySelectorAll("[data-ld-sticky-bar]").forEach(init);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
